import React, { useState } from 'react';

import { useTranslation, I18nextProvider } from 'react-i18next';

import { PageContextProvider } from '../hooks/usePageContext';
import i18next from '../utils/i18next';
import { Locale } from '../utils/i18nUtils';
import { CookieConsent } from './CookieConsent';

type Props = {
  children: React.ReactNode;
  locale: Locale;
};

export const PageWrapper: React.FunctionComponent<Props> = ({ children, locale }) => {
  const { i18n } = useTranslation();
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  if (i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }
  return (
    <I18nextProvider i18n={i18next}>
      <PageContextProvider pageContext={{ showCookieSettings, setShowCookieSettings }}>
        <CookieConsent />
        {children}
      </PageContextProvider>
    </I18nextProvider>
  );
};
